import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Card, Modal, Map, HRSelect, TableCard, DeleteButton } from 'components';
import PieCharts from './components/PieCharts';
import { FcAcceptDatabase, FcComboChart, FcDeployment, FcDonate, FcPackage, FcShipped } from "react-icons/fc";
import { GiChart } from "react-icons/gi";
import { CiBoxes, CiGrid2H, CiShoppingCart } from "react-icons/ci";
import { LiaTruckLoadingSolid } from "react-icons/lia";

import AreaCharts from './components/AreaCharts';
import trend from '../../assets/images/trend.png';
import check from '../../assets/images/check.png';
import warning from '../../assets/images/warning.png';
import calendar from '../../assets/images/calendar.png';
import { IoIosArrowForward } from "react-icons/io";
import { IoFilterOutline } from "react-icons/io5";
import { DatePicker, Table, Tag } from 'antd';
import BarCharts from './components/BarCharts';
import { FaCaretRight, FaChartLine, FaPen } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { PiTruckThin } from 'react-icons/pi';
import { TbBrandAppgallery } from 'react-icons/tb';
import { HiOutlineArrowsRightLeft } from 'react-icons/hi2';
const status = [

  { label: <Tag  color="processing">Хүсэлт</Tag>, value: 1 },
  // { label: <Tag color="processing">Баталгаажсан</Tag>, value: 1 },
  // { label: <Tag color="processing">Идэвхгүй</Tag>, value: 1 },
  // { label: <Tag color="processing">Идэвхгүй</Tag>, value: 1 },
];  
function Dashboard() {
  const [ data, setData ] = useState({});
  const [ month_order, setMonth_order ] = useState([]);
  const [ total, setTotal ] = useState([]);
  const [ order, setOrder ] = useState([]);
  const [ age, setAge ] = useState([]);
  const [ workYear, setWorkYear ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const orderList = [ {name: 'orderList',  value: order.length}]

  console.log('total ->? ', total);
  const test = [
    {value1: 10, value2: 10,   name: '1 сар'},
    {value1: 15, value2: 15,   name: '2 сар'},
    {value1: 5, value2: 5,  name: '3 сар'},
    {value1: 20, value2: 20,   name: '4 сар'},
    {value1: 25, value2: 25,   name: '5 сар'},
    {value1: 30, value2: 30,   name: '6 сар'},
    {value1: 50, value2: 50,   name: '7 сар'},
    {value1: 45, value2: 45,   name: '8 сар'},
    {value1: 80, value2: 80,   name: '9 сар'},
    {value1: 35, value2: 35,   name: '10 сар'},
    {value1: 100, value2: 100, name: '11 сар'},
    {value1: 90, value2: 90,   name: '12 сар'},
  ]
  useEffect(() => {
    // getData();
    getMonth_order();
    getTotal()
    getOrder()
    // getEducation();
    // getAge();
    // getWorkYear();
  },[]);
  
  const getData = () => {
    setLoading(true)
    axios({
      method: 'get',
      url:'/dashboard'
    }).then((res) => {
        setData(res.data)
    }).catch((err) => {
    }).finally(() => setLoading(false))
  }

  const getMonth_order = () => {
    setLoading(true);
    axios({
      method: 'get',
      url:'/dashboard/month-order',
    }).then((res) => {
      setMonth_order(res.data);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };

  const getTotal = () => {
    setLoading(true);
    axios({
      method: 'get',
      url:'/dashboard/total',
    }).then((res) => {
      setTotal(res.data);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };
  const getOrder = () => {
    setLoading(true);
    axios({
      method: 'get',
      url: 'orders',
    }).then((res) => {
      const filteredData = res.data.filter(order => order.status === 3);
      setOrder(filteredData);
      // setOrder(res.data);
    }).catch((err) => {
    }).finally(() => setLoading(false));
  };
  const getAge = () => {
    setLoading(true);
    axios({
      method: 'get',
      url:'age_chart',
    }).then((res) => {
      setAge(res.data);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };
  const getWorkYear = () => {
    setLoading(true);
    axios({
      method: 'get',
      url:'workyear_chart',
    }).then((res) => {
      setWorkYear(res.data);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };
  
  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      width: 50,
      align: "center",
      render: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "Барааны код",
      dataIndex: "productCode",
      key: "productCode",
      // render: (value, data) => (
      //   <div className="flex flex-row">
      //    <div className="action-cell flex items-center gap-2"><FaCaretRight />
      //   </div><Link to={`/order/${data?.id}`}>{value}</Link>
      //   </div>
      // )
    },
    {
      title: "Барааны нэр",
      dataIndex: "productName",
      key: "productName",
      // cellRender:({value, data}) =>(
      //   <div>{costumer.find((item) => item?.value === value)?.label}</div>     
      // ) 
      
    },
    {
      title: "Үнэ",
      dataIndex: "price",
      key: "price",
      // cellRender:({value, data}) =>(
      //   <div>{payment.find((item) => item?.value === value)?.label}</div>     
      // ) 
    },
    {
      title: "Дэлгүүрийн үлдэгдэл",
      dataIndex: "storeProduct",
      key: "payedamount",
    },
    {
      title: "Агуулахын үлдэгдэл",
      dataIndex: "warehouseProduct",
      key: "status",
      // render:({value, data}) =>(
      //   <div>{status.find((item) => item?.value === value)?.label}</div>     
      // ) 
    },
    {
        title: 'Төлөв',
        dataIndex: 'status',
        key: 'status',
        // cellRender: ({value, data}) => (
        //     <>{dayjs(value).format('YYYY-MM-DD')}</>
        // )
    },
    // {
    //   title: "",
    //   dataIndex: "action",
    //   key: "action",
    //   width: 90,
      // render: ({ value, data }) => (
      //   <div className="action-cell flex items-center gap-2">
      //     <Button
      //       type="ghost"
      //       size="sm"
      //       icon={<FaPen />}
            // onClick={() => handleEditButton(data)}
      //     />
      //     <DeleteButton 
          // onClick={() => handleDelete(data)} 
      //     />
      //   </div>
      // ),
    // },
  ];
  return (
    <div className='grid grid-rows-3 grid-flow-col gap-4'>
      <Card className='row-span-2 grid grid-cols-9 gap-6'>
        <div style={{height: '120px', background: 'linear-gradient(to right, #f3f7f2, #638cf2)' }} className='col-span-3 text-[#383838] grid grid-cols-3 items-center  rounded-xl border-4 border-sky-500'>
          <div className='px-4 py-2 rounded-2xl bg-cardbg my-6 m-4 col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Нийт захиалга</p>
            </div>
            <span className='text-lg text-left font-semibold'>{total?.order}</span>
          </div>
            <CiShoppingCart 
            style={{ color: 'white' }} 
             size={70}/>
        </div>
        <div style={{ height: '120px',background: 'linear-gradient(to right, #f3f7f2, #638cf2)' }} className=' col-span-3 text-[#383838] grid grid-cols-3 items-center rounded-xl border-4 border-sky-500'>
        <div className='px-4 py-2 rounded-2xl bg-cardbg my-6 m-4 col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Нийт үлдэгдэл</p>
            </div>
            <span className='text-lg text-left font-semibold'>{total?.balance}</span>
          </div>
          <CiGrid2H  style={{color:'white'}} size={70}/>
        </div>
        <div style={{ height: '120px', background: 'linear-gradient(to right, #f3f7f2, #638cf2)' }} className='col-span-3 text-[#383838] grid grid-cols-3 items-center rounded-xl border-4 border-sky-400'>
          {/* <PieCharts colors={["#6B6B6B"]} legendHide={true} data={[{ label: 'test', value: 70}]} /> */}
          <div className='px-4 py-2 rounded-2xl bg-cardbg my-6 m-4 col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Нийт бараа</p>
            </div>
            <span className='text-lg text-left font-semibold'>{total?.product}</span>
          </div>
          <CiBoxes style={{color:'white'}} size={70}/>
        </div>
        <div style={{ height: '120px', background: 'linear-gradient(to right, #f3f7f2, #638cf2)' }} className='col-span-3 text-[#383838] grid grid-cols-3 items-center rounded-xl border-4 border-sky-400'>
          {/* <PieCharts colors={["#6B6B6B"]} legendHide={true} data={[{ label: 'test', value: 70}]} /> */}
          <div className='px-4 py-2 rounded-2xl bg-cardbg my-6 m-4 col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              {/* <p>Нийт</p> */}
              <p>Өнөөдрийн тооцоо</p>
            </div>
            <span className='text-lg text-left font-semibold'>{total?.totalamount}</span>
          </div>
          <GiChart style={{color: 'white'}}  size={70}/>
        </div>
        <div style={{ height: '120px', background: 'linear-gradient(to right, #f3f7f2, #638cf2)' }} className='col-span-3 text-[#383838] grid grid-cols-3 items-center rounded-xl border-4 border-sky-500'>
          {/* <PieCharts colors={["#6B6B6B"]} legendHide={true} data={[{ label: 'test', value: 70}]} /> */}
          <div className='px-4 py-2 rounded-2xl bg-cardbg my-6 m-4 col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              {/* <p>Нийт</p> */}
              <p>Цуцалсан, Буцаасан</p>
            </div>
            <span className='text-lg text-left font-semibold'>{total.orderReturn}</span>
          </div>
          <HiOutlineArrowsRightLeft style={{color:'white'}} size={70}/>
        </div>
        <div style={{ height: '120px', background: 'linear-gradient(to right, #f3f7f2, #638cf2)' }} className='col-span-3 text-[#383838] grid grid-cols-3 items-center rounded-xl border-4 border-sky-500'>
          {/* <PieCharts colors={["#6B6B6B"]} legendHide={true} data={[{ label: 'test', value: 70}]} /> */}
          <div className='px-4 py-2 rounded-2xl bg-cardbg my-6 m-4 col-span-2 grid grid-row-2 shadow-md' >
            <div className='text-sm space-x-4 font-bold flex flex-row'>
              <p>Татан авалт</p>
            </div>
            <span className='text-lg text-left font-semibold'>{total?.buying}</span>
          </div>
          <LiaTruckLoadingSolid style={{color:'white'}} size={70}/>
        </div>
        
        <Card className='col-span-9'>
          <div className='flex justify-between items-center mb-6'>
            <h1 className='text-base'>Борлуулалтын тойм /сараар/ </h1>
            <div className='flex gap-2 items-center text-[#383838]'>
              <DatePicker.MonthPicker placeholder='Энэ сар' className='rounded-xl py-2 px-6' />
              <button onClick={() => {}} className='py-3 px-6 border rounded-xl flex gap-2 items-center'>Шүүлтүүр <IoFilterOutline className='text-base'/></button>
            </div>
          </div>
            <BarCharts data={month_order} />
        </Card>
      </Card> 
        <TableCard>
          <Table 
            columns={columns} 
            loading={loading}
          />
        </TableCard>
        <div style={{ width: '300px', overflow: 'visible' }} className='row-span-3'>
          <div className='grid items-center w-full mb-6'>
            {/* <h1 className='text-lg m-4'>Нийт захиалга</h1> */}
            <div style={{ width: '100%', height: '100%' }}>
              <Card>
              <PieCharts colors={["#533dbf"]} legendHide={true} data={orderList} />
              <div className='col-span-2 grid grid-cols-2 items-start'>
                <div className='text-sm'>
                  <p>Нийт</p>
                  <p>Хүргэлтийн хүсэлт</p>
                </div>
                <span className='text-2xl text-right font-semibold'>{order.length}</span>
              </div>
              <div className='col-span-2 mt-4 flex gap-2'>
              </div>

              </Card>
            </div>
          </div> 
          <h1 className='text-lg m-4'>Хүргэлт</h1>
          <div className='grid items-center w-full mb-6 gap-4 overflow-y-auto max-h-[650px]'>
           
            {order.map(order => (
                <Card key={order.id}>
                  <div className='col-span-2 grid grid-cols-2 items-start '>
                    <div className='text-sm'>
                      <p className='text-lg text-left font-semibold'>Хүргэлттэй</p>
                      <p className='text-lg text-left font-semibold'>{order.title}</p>
                    </div>
                    <span className='text-lg text-right'>{order.orderdate}</span>
                  </div>
                  <div className='col-span-2 mt-4 flex gap-2'>
                    {/* Additional content here */}
                  </div>
                  <Link to={`/order/${order.id}`}>
                    <Button type='primary' className='w-full'>
                      Харах
                    </Button>
                  </Link>
                </Card>
              ))}
          </div>
        </div>
    </div>
    // <div className='grid grid-cols-12 gap-4'>
      // <div className='col-span-3 flex justify-between px-6 py-4 bg-cardbg rounded-2xl'>
      //   <span>{data?.employee}</span>
      //   <p>Ажилчид</p>
      // </div>
    //   <div className='col-span-3 flex justify-between px-6 py-4 bg-cardbg rounded-2xl'>
    //     <span>{data?.department}</span>
    //     <p>Салбар нэгж</p>
    //   </div>
    //   <div className='col-span-3 flex justify-between px-6 py-4 bg-cardbg rounded-2xl'>
    //     <span>{data?.sector}</span>
    //     <p>Алба хэлтэс</p>
    //   </div>
    //   <div className='col-span-3 flex justify-between px-6 py-4 bg-cardbg rounded-2xl'>
    //     <span>{data?.position}</span>
    //     <p>Албан тушаал</p>
    //   </div>
    //   <Card className='col-span-4'>
    //     <h1 className='text-2xl text-black-text font-medium'>Боловсролын түвшин</h1>
    //     <PieCharts data={education} />
    //   </Card>
    //   <Card className='col-span-4'>
    //     <h1 className='text-2xl text-black-text font-medium'>Хүйсийн харьцаа</h1>
    //     <PieCharts data={gender} />
    //   </Card>
    //   <Card className='col-span-4'>
    //     <h1 className='text-2xl text-black-text font-medium'>Гэр бүлийн байдал</h1>
    //     <PieCharts data={family} />
    //   </Card>
    //   <Card className='col-span-6'>
    //     <div className='flex items-end gap-2'>
    //       <h1 className='text-2xl text-black-text font-medium'>Ажилчдын насны ангилал</h1>
    //     </div>
    //     <AreaCharts data={age} />
    //   </Card>
    //   <Card className='col-span-6'>
    //     <div className='flex items-end gap-2'>
    //       <h1 className='text-2xl text-black-text font-medium'>Ажилласан жилийн тайлан</h1>
    //     </div>
    //     <AreaCharts data={workYear} />
    //   </Card>
    // </div>
  );
};

export default Dashboard;